export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Oglasi',
        to: '/',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Kvartovi',
        to: '/Hoods',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Blacklist agencija',
        to: '/PublisherBlacklist',
        icon: 'cil-ban'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Scraper',
        to: '/Scraper',
        icon: 'cil-speedometer'
      },
      {
        _name: 'CSidebarNavDivider',
        _class: 'm-2'
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Logout',
        to: '/logout',
        icon: 'cil-lock-locked'
      },
    ]
  }
]
